export const getVisiblePageNumbers = (
  currentPage,
  totalPages,
  siblingCount = 1,
  boundaryCount = 1,
) => {
  const totalPageNumbers = siblingCount * 2 + boundaryCount * 2 + 3;

  if (totalPages <= totalPageNumbers) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  const pages = [];
  const leftSiblingIndex = Math.max(
    currentPage - siblingCount,
    boundaryCount + 2,
  );
  const rightSiblingIndex = Math.min(
    currentPage + siblingCount,
    totalPages - boundaryCount - 1,
  );

  for (let i = 1; i <= boundaryCount; i += 1) {
    pages.push(i);
  }

  if (leftSiblingIndex > boundaryCount + 2) {
    pages.push('left-ellipsis');
  } else {
    for (let i = boundaryCount + 1; i < leftSiblingIndex; i += 1) {
      pages.push(i);
    }
  }

  for (let i = leftSiblingIndex; i <= rightSiblingIndex; i += 1) {
    pages.push(i);
  }

  if (rightSiblingIndex < totalPages - boundaryCount - 1) {
    pages.push('right-ellipsis');
  } else {
    for (let i = rightSiblingIndex + 1; i <= totalPages - boundaryCount; i += 1) {
      pages.push(i);
    }
  }

  for (let i = totalPages - boundaryCount + 1; i <= totalPages; i += 1) {
    pages.push(i);
  }

  return pages;
};

